(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function groupFaq(section) {
    const list = section.querySelector('.collapsible-content-list-block');
    if (!list || list.querySelector(':scope > .boviisky-faq-category')) return;

    let body = null;
    let categoryIndex = 0;
    for (const item of Array.from(list.children)) {
      if (item.matches('.collapsible-content-title-block')) {
        const group = document.createElement('details');
        const summary = document.createElement('summary');
        body = document.createElement('div');
        group.className = 'boviisky-faq-category';
        body.className = 'boviisky-faq-category-body';
        group.open = categoryIndex === 0;
        categoryIndex += 1;
        summary.append(item);
        group.append(summary, body);
        list.append(group);
      } else if (body) {
        body.append(item);
      }
    }
  }

  function ungroupFaq(section) {
    const list = section.querySelector('.collapsible-content-list-block');
    if (!list) return;

    for (const group of Array.from(list.querySelectorAll(':scope > .boviisky-faq-category'))) {
      const heading = group.querySelector(':scope > summary > .collapsible-content-title-block');
      const body = group.querySelector(':scope > .boviisky-faq-category-body');
      if (heading) list.insertBefore(heading, group);
      while (body?.firstChild) list.insertBefore(body.firstChild, group);
      group.remove();
    }
  }

  function updateFaq(root = document) {
    for (const section of root.querySelectorAll('.boviisky-product-faq')) {
      if (mobile.matches) groupFaq(section);
      else ungroupFaq(section);
    }
  }

  updateFaq();
  mobile.addEventListener('change', () => updateFaq());
  document.addEventListener('shopify:section:load', (event) => updateFaq(event.target));
})();
